export interface DestinationMenuSubItemDto {
	label: string;
	routeUrl: string;
}

export class DestinationMenuItemDto {
	routeUrl = '';
	subItems: DestinationMenuSubItemDto[] = [];

	static createEmpty(): DestinationMenuItemDto {
		return new DestinationMenuItemDto();
	}
}

export interface DestinationMenuConfigurationDto {
	[key: string]: DestinationMenuItemDto;
}

export interface DestinationMenuItem extends DestinationMenuItemDto {
	key: string;
}
